import React from "react";

const BubbleChatIcon = ({ ...rest }) => (
  <svg
    {...rest}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_38_1311)">
      <path
        d="M22.5024 17.3316C24.8216 14.0777 24.4671 9.61964 21.2994 6.71569C19.852 5.38889 18.0069 4.56291 16.0137 4.33223C16.0013 4.31695 15.9886 4.30181 15.9747 4.28733C14.2407 2.48616 11.7496 1.45312 9.14006 1.45312C4.17417 1.45312 0 5.15311 0 9.89062C0 11.5516 0.515953 13.1439 1.49606 14.5191L0.126891 18.8178C0.0408281 19.088 0.125484 19.3834 0.341531 19.567C0.557953 19.7509 0.86325 19.7863 1.11548 19.658L5.27925 17.5408C6.13434 17.909 7.04109 18.1506 7.98009 18.2605C9.79144 20.1653 12.296 21.1406 14.8584 21.1406C16.1904 21.1406 17.5176 20.8692 18.7191 20.3532L22.883 22.4705C22.9838 22.5218 23.093 22.5469 23.2015 22.5469C23.676 22.5469 24.0162 22.0845 23.8716 21.6303L22.5024 17.3316ZM5.56303 16.126C5.36611 16.0325 5.13703 16.0356 4.94273 16.1344L1.97709 17.6423L2.94553 14.6017C3.01603 14.3804 2.97267 14.1385 2.82961 13.9554C1.89839 12.7634 1.40616 11.3579 1.40616 9.89062C1.40616 6.01359 4.87556 2.85938 9.14006 2.85938C10.8574 2.85938 12.5106 3.37964 13.8517 4.31653C9.33534 4.77066 5.71837 8.29819 5.71837 12.7031C5.71837 14.0732 6.06956 15.3922 6.73167 16.5739C6.3308 16.4545 5.94037 16.3052 5.56303 16.126ZM19.0558 18.9468C18.8643 18.8495 18.635 18.8436 18.4355 18.9385C17.3393 19.4592 16.1024 19.7344 14.8584 19.7344C10.5939 19.7344 7.12453 16.5802 7.12453 12.7031C7.12453 8.82609 10.5939 5.67188 14.8584 5.67188C19.1229 5.67188 22.5923 8.82609 22.5923 12.7031C22.5923 14.1704 22.1001 15.5759 21.1688 16.7679C21.0258 16.9509 20.9825 17.1928 21.0529 17.4142L22.0214 20.4548L19.0558 18.9468Z"
        fill="#D33479"
      />
      <path
        d="M11.9993 13.4062C12.3876 13.4062 12.7024 13.0915 12.7024 12.7031C12.7024 12.3148 12.3876 12 11.9993 12C11.6109 12 11.2961 12.3148 11.2961 12.7031C11.2961 13.0915 11.6109 13.4062 11.9993 13.4062Z"
        fill="#D33479"
      />
      <path
        d="M14.8116 13.4062C15.1999 13.4062 15.5147 13.0915 15.5147 12.7031C15.5147 12.3148 15.1999 12 14.8116 12C14.4233 12 14.1085 12.3148 14.1085 12.7031C14.1085 13.0915 14.4233 13.4062 14.8116 13.4062Z"
        fill="#D33479"
      />
      <path
        d="M17.6239 13.4062C18.0122 13.4062 18.327 13.0915 18.327 12.7031C18.327 12.3148 18.0122 12 17.6239 12C17.2356 12 16.9208 12.3148 16.9208 12.7031C16.9208 13.0915 17.2356 13.4062 17.6239 13.4062Z"
        fill="#D33479"
      />
    </g>
    <defs>
      <clipPath id="clip0_38_1311">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default BubbleChatIcon;
